export default __webpack_public_path__ + "static/media/duplicate.a7c68dbf.svg";